<template>
  <div class="wrapper">
    <div class="container">
      <h3 class="title">Tracking code installation</h3>
      <p class="sub-title">This code allow us to monitor incoming paid traffic on your website.<br> Place it right after the opening &lt;body&gt; tag on all your landing pages.</p>
      <add-script-component />
    </div>
  </div>
</template>

<script>
import ReportHero from "@/components/report/2/Hero";
import AddScriptComponent from "@/components/steps/AddScript";

export default {
  name: "AddScript",
  components: {
    ReportHero,
    AddScriptComponent,
  }
}
</script>

<style lang="scss" scoped>
@import "src/assets/style/responsive";
.wrapper {
  display: block;
  min-height: 100vh;
  background: transparent linear-gradient(180deg, #FDFBFA 0%, #FBF5F3 72%, #FFFFFF 100%) 0% 0% no-repeat padding-box;
  padding: 80px 0 108px;

  @include mobile {
    background: transparent linear-gradient(180deg, #FCFAF9 0%, #FFFFFF 49%, #FAF4F2 100%) 0% 0% no-repeat padding-box;
  }
}
</style>